
import Vue, {PropOptions} from 'vue';
import { getImageSize } from '~/lib/util/dom_utils';
import CropperImg from './CropperImg.vue';
import Modal from './Modal.vue';


export default Vue.extend({
  components: {
    CropperImg: CropperImg,
    Modal: Modal,
  },
  data() {
    let autoCropArea = 1.0;  // 1.0 so that cropper fills whole <img/> initial space

    return {
      photoUrl: undefined as string | undefined,
      minZoom: autoCropArea,
      maxZoom: 3.0,
      zoom: autoCropArea,  // initial zoom same as autoCropArea so image fits vertically
      autoCropArea,
      rotation: 0,
      h: 2000,
      w: 1000,
      outerH: Math.round(0.5 * window.innerHeight),
      outerW: '100%' as string | number,
      imageWidth: 0,
      imageHeight: 0,
      modalVisible: false,
      scale: 1.0
    }
  },
  methods: {
    close() {
      this.photoUrl = undefined;
      this.modalVisible = false;
    },
    async save() {
      const $cropper: any = this.$refs.cropper;

      if(this.$refs.cropper) {
        const blob = await $cropper.getCroppedBlob();
        this.$emit('croppedBlob', {blob, originalPhotoUrl: this.photoUrl} as CropperPhotoEvent);
      }
    },
    updateWH() {
      // @ts-ignore
      const xxx2: HTMLElement = this.$refs.xxx2;
      if(! xxx2) {
        console.error('xxx2 not found');
        return;
      }

      const xxx2Width = xxx2.clientWidth;

      console.log(`xxx2Width`, xxx2Width)

      this.outerW = xxx2Width;

      const imageAspectRatio = this.imageWidth / this.imageHeight;


      if(imageAspectRatio <= 1) {
        const w_scale = this.outerW / this.imageWidth;
        this.h = this.imageHeight * w_scale;  // now image fills width 100%
        this.w = this.outerW;

        this.h /= 1.1;
      } else {


        const w_scale = this.outerW / this.imageWidth;
        const h_scale = this.outerH / this.imageHeight;
        this.h = this.outerH;

        // this.scale = 2;
        // console.log('scale', this.scale)
        // this.minZoom /= this.scale;
        // this.maxZoom /= this.scale;

        // console.log('scale ->', this.scale)
        // this.h = this.imageHeight * w_scale;  // now image fills width 100%
        // this.h = this.outerH;
        // this.w = this.outerW;
        // this.w = this.imageWidth * h_scale;  // now image fills height 100%
        // this.w = 'auto';  // now image fills height 100%
        // this.w /= 1.1;
        // this.w = 2000;
      }


      const boxAspectRatio = this.outerW / this.outerH;

      // We set the height to `h / boxAspectRatio`, so that the crop circle is
      // always the same size, regardless if we have vertical or horizontal images
      // We also divide by 1.1 so that we have some space around the image when user
      // rotates the image.
      // this.h = Math.max(this.h / boxAspectRatio, this.outerH) / 1.5;
      // this.h = 300;
    }
    // updateImageData(data: Cropper.ImageData) {
    //   console.log('updateImageData', data);
    // }
  },
  mounted() {
    this.$on('open', async (filePhoto: File | string) => {

      // const host = 'https://thinkpad.tail0a4ec.ts.net';
      // const host = 'https://kupujipomagaj.internal';
      // // filePhoto = `${host}/media/2000x1000.png`;
      // filePhoto = `${host}/media/1000x2000.png`;
      // // filePhoto = `${host}/media/2000x1500.png`;
      // // filePhoto = `${host}/media/2000x2000.png`;
      // // filePhoto = `${host}/media/3000x10000.png`;

      let photoUrl: string;

      if(filePhoto instanceof File) {
        const urlCreator = window.URL || window.webkitURL;
        photoUrl = urlCreator.createObjectURL(filePhoto);
      } else {
        photoUrl = filePhoto;
        if(photoUrl.startsWith('http://')) {
          photoUrl = photoUrl.replace('http://', 'https://');
        }
      }

      const {width, height} = await getImageSize(photoUrl);
      console.log('width', width, 'height', height);

      this.imageWidth = width;
      this.imageHeight = height;

      this.modalVisible = true;
      await this.$nextTick();
      this.updateWH();

      await this.$nextTick();

      this.photoUrl = photoUrl;

      await this.$nextTick();
      // this.$refs.cropper.scale(this.scale);
    });
    this.$on('close', () => this.close());
  },
})
